import React, { useEffect, useState } from 'react';
import './Home.css'
import Sidebar from '../Components/Layout/Sidebar';
import { Header } from '../Components/Layout/Header';
import PageTitle from '../Components/Common/PageTitle';
import StatCard from '../Components/Common/StatCard';

import Lightning from '../Assets/Icons/Lightning.svg'
import Ev from '../Assets/Icons/Ev.svg'
import Users from '../Assets/Icons/Users.svg'
import Bookings from '../Assets/Icons/Bookings.svg'
import BookingChart from '../Components/Layout/BookingChart';
import { supabase } from '../supabase';


const Home = () => {

    const [bookings, setBookings] = useState([]);
    const [users, setUser] = useState([]);
    const [cars, setCars] = useState([]);

    const getData = async() => {
        const bookingData = await supabase.from('bookings').select('*');
        setBookings(bookingData.data)

        const userData = await supabase.from('users').select('*');
        setUser(userData.data);

        const carsData = await supabase.from('fleet').select('*');
        setCars(carsData.data);
    }

    useEffect(() => {
        getData();
        console.log(bookings)
    } , [])

    return ( 
        <main className='Home'>
            <Sidebar />

            <div className='MainContent'>
                <Header />

                <div className='PageCards'>
                    <PageTitle TitleText='Event Performance Overview' SubText='Real-time data for Electrify Egypt 2024' HeaderBtnsClass='NoHeaderBtns'/>

                    <section className='StatCards'>
                        <StatCard SCardLabel="TOTAL BOOKINGS" SCardValue={bookings.length} SCardIcon={Bookings}/>
                        <StatCard SCardLabel="TODAY'S ATTENDEES" SCardValue={users.length} SCardIcon={Users}/>
                        <StatCard SCardLabel="REGISTERED EVS" SCardValue={cars.length} SCardIcon={Ev}/>
                    </section>

                    <div className='Activity'>
                        <BookingChart />
                    </div>
                </div>
            </div>
        </main>
     );
}
 
export default Home;